import { TextField } from '@mui/material'
import { useRecurrenceEndOccurrenceProps } from './useRecurrenceEndOccurrenceProps'

type RecurrenceEndOccurrencePickerProps = {
  requiredRecurrences: number
}

export function RecurrenceEndOccurrencePicker(props: RecurrenceEndOccurrencePickerProps) {
  const { requiredRecurrences } = props
  const textFieldProps = useRecurrenceEndOccurrenceProps(requiredRecurrences)

  return <TextField {...textFieldProps} />
}
